export const extractNumber = (
  value?: string | number | null
): string | null => {
  if (typeof value === 'number') return String(value);
  if (value === null || value === undefined) return null;

  const match = String(value).match(/-?\d+(\.\d+)?/);
  if (!match) return null;

  return match[0];
};
